import { DocumentEntity } from "../../domain/entities/Document";

export type DocumentCategory =
  | "all"
  | "invoice"
  | "bill"
  | "bank_statement"
  | "credit_card";

export const DOCUMENT_CATEGORY_OPTIONS: Array<{
  label: string;
  value: DocumentCategory;
}> = [
  { label: "All", value: "all" },
  { label: "Invoice", value: "invoice" },
  { label: "Bill", value: "bill" },
  { label: "Bank Statement", value: "bank_statement" },
  { label: "Credit Card", value: "credit_card" },
];

export const matchesDocumentCategory = (
  doc: DocumentEntity,
  category: DocumentCategory,
) => {
  if (category === "all") return true;

  if (category === "bank_statement") {
    return doc.type === "statement" && doc.statementType === "bank";
  }

  if (category === "credit_card") {
    return doc.type === "statement" && doc.statementType === "credit";
  }

  return doc.documentType === category;
};
